export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9123.4ec5c906.jpg";